import { CloudXIntegrationDataSchema } from "@redotech/redo-model/integration/cloudx/types";
import { null as zNull } from "zod/v4";

export const postCloudXIntegration = {
  name: "postCloudXIntegration" as const,
  input: CloudXIntegrationDataSchema,
  output: zNull(),
};
